"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexClientModel = void 0;
var loader_1 = require("./loader");
var IndexClientModel = (function () {
    function IndexClientModel() {
    }
    IndexClientModel.prototype.Init = function () {
        var _this = this;
        this.FormBuy = document.getElementById('js-buy-form');
        var buyZip = this.FormBuy.querySelector('input[type="text"]');
        var buyTenantList = document.getElementById('js-buy-tenant-list');
        this.FormBuy.addEventListener('submit', function (e) {
            e.preventDefault();
            _this.LoadSupplier(_this.FormBuy, buyZip, buyTenantList, '.toggle-supplier');
        });
        this.FormSell = document.getElementById('js-sell-form');
        if (this.FormSell != null) {
            var sellZip_1 = this.FormSell.querySelector('input[type="text"]');
            var sellTenantList_1 = document.getElementById('js-sell-tenant-list');
            this.FormSell.addEventListener('submit', function (e) {
                e.preventDefault();
                _this.LoadSupplier(_this.FormSell, sellZip_1, sellTenantList_1, '.toggle-buyer');
            });
        }
    };
    IndexClientModel.prototype.LoadSupplier = function (form, zipInput, tenantList, toggle) {
        var validation = $(form).validate();
        if (validation.numberOfInvalids() > 0) {
            return;
        }
        form.setAttribute('data-busy', 'true');
        zipInput.disabled = true;
        var zip = zipInput.value;
        var url = form.action;
        var me = this;
        $.getJSON(url + '/' + zip, function (data) {
            var buttons = tenantList.querySelectorAll('button');
            for (var i = 0; i < buttons.length; i++) {
                tenantList.removeChild(buttons[i]);
            }
            for (var i = 0; i < data.length; i++) {
                var btn = document.createElement('button');
                btn.type = 'submit';
                btn.formAction = data[i].Url;
                btn.name = 'zipcode';
                btn.value = zip;
                btn.classList.add('list-group-item');
                btn.classList.add('list-group-item-action');
                if (i == 0)
                    btn.classList.add('rounded-top');
                btn.innerText = data[i].Name;
                tenantList.appendChild(btn);
            }
            if (data.length == 0) {
                $(tenantList).parent().find('#no-supplier').show();
            }
            else {
                $(tenantList).parent().find('#no-supplier').hide();
            }
            if (me.HasBranding && data.length == 1) {
                $(tenantList).parent().find('.waiting-message').show();
                $(tenantList).find('button[type="submit"]').click();
            }
            $(toggle).collapse('toggle');
            form.setAttribute('data-busy', '');
            zipInput.disabled = false;
        });
    };
    return IndexClientModel;
}());
exports.IndexClientModel = IndexClientModel;
(0, loader_1.InitClientContext)(IndexClientModel);
